import * as H from 'history'
import  React from 'react'
import { Alert } from 'react-bootstrap'
import { ClaimController } from '../../../../controllers/ClaimController'
import { ClaimModel } from '../../../../models/ClaimModel'
import { FinancialAssistance } from '../../../../models/FinancialAssistance'
import { ISupportSpinner } from '../../../../shared/Ajax'
import { Backdrop } from '../../../../shared/Backdrop'
import { Table } from '../../../../shared/table'
import { getFY } from '../../../../shared/Utility'
import { SaveCancelButtons } from '../../controls/SaveCancelButtons'
import { financialAssistanceColumns, FinancialAssistanceDetails } from './FinancialAssistanceDetails'

export interface FinancialAssistancePageProps {
    history: H.History
    model: ClaimModel
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
}

export interface FinancialAssistancePageState {
    loading: boolean
    financialAssistance: FinancialAssistance[]
}

export class FinancialAssistancePage extends React.Component<FinancialAssistancePageProps, FinancialAssistancePageState> implements ISupportSpinner {
    ajax: ClaimController
    table: Table<FinancialAssistance>

    constructor(props: FinancialAssistancePageProps) {
      super(props)

      this.ajax = new ClaimController()

      this.state = {
        loading: false,
        financialAssistance: props.model.financialAssistance ? props.model.financialAssistance.map((r) => r) : [],
      }
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    save = () => {
      this.table.saveAndClose((res) => {
        if (res) {
          if (this.state.financialAssistance.filter((r) => r.invalid).length == 0) {
            this.props.onChange({ financialAssistance: this.state.financialAssistance }, () => {
              this.ajax.updateClaim(this, this.props.model, () => {
                this.props.history.goBack()
              })
            })
          } else {
            alert('Please correct records marked with the warning sign.')
          }
        }
      })
    }

    render() {
      const columns = [...financialAssistanceColumns]

      const sortedList = this.state.financialAssistance.slice()
      sortedList.sort((a, b) => (a.invalid ? -1 : 1))

      return (
        <>
          <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />
          <h2 className="mt-3">Grants or reimbursement received from government or third parties</h2>
          <div className="mt-3 mb-3">
            <Alert className="emdg-page-alerts">
              <p>Do NOT claim any reimbursed amounts in your schedule. E.g. the total expenses was $500 but you were reimbursed $200. You can claim $300 in your EMDG application.</p>
            </Alert>
          </div>
          <Table<FinancialAssistance>
            id="table"
            label="Grants or reimbursement received from government or third parties"
            ref={(r) => this.table = r}
            value={sortedList}
            onChange={(financialAssistance) => this.setState({ financialAssistance })}
            columns={columns}
            renderSection={(p) => <FinancialAssistanceDetails {...p} />}
            match={(a, b) => a.id == b.id}
            allowEdit
            alwaysShowAllRows
          />

          <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

          <Backdrop on={this.state.loading} />
        </>
      )
    }
}
